export default __webpack_public_path__ + "static/media/icon-close-support.fa955f0a.svg";